module.exports = ".example-icon {\n    padding: 0 14px;\n  }\n  \n  .example-spacer {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n  }\n  \n  .design{\n      padding-top: 0px;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master.component.css
// module id = ./src/app/master/master.component.css
// module chunks = main